module.exports = __webpack_public_path__ + "static/media/twitter.3bcae305.svg";